import Page from '../components/Page';
import { AnimatePresence, motion } from 'framer-motion';
import { useAppStore } from '../stores/useAppStore';
import ExpandButton from '../components/ExpandButton';
import RefreshButton from '../components/RefreshButton';
import { useState, useEffect } from 'react';

const MotionExpandButton = motion.create(ExpandButton);
const RefreshExpandButton = motion.create(RefreshButton);

const defaultPageVariants = {
  normal: {
    paddingTop: '8.375rem',
    paddingBottom: '8.375rem',
    paddingLeft: '0rem',
    paddingRight: '18.75rem',
    transition: { duration: 0.3, ease: "easeInOut" },
  },
  fullScreen: {
    padding: '0rem',
    transition: { duration: 0.3, ease: "easeInOut" },
  },
};

const defaultIframeContainerVariants = {
  normal: {
    padding: '1.375rem',
    transition: { duration: 0.3, ease: "easeInOut" },
  },
  fullScreen: {
    padding: '0rem',
    transition: { duration: 0.3, ease: "easeInOut" },
  },
};

export function PageWithIframeLayout({
    className = '',
    iframeSrc,
    pageVariants = defaultPageVariants,
    iframeContainerVariants = defaultIframeContainerVariants,
    expandButtonClassName = "absolute top-[8.375rem] right-[9.2rem] w-[6.875rem] h-[6.875rem] focus:outline-none",
    expandButtonAnimation = {
        initial: { x: "+200%", opacity: 0 },
        animate: { x: 0, opacity: 1 },
        exit: { x: "+200%", opacity: 0 },
    },
    children,
}) {
  const { fullScreen, toggleFullScreen } = useAppStore();
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(iframeSrc);

  // Resetea la opacidad y cambia la URL del iframe cuando cambia iframeSrc
  useEffect(() => {
    setIframeLoaded(false);  // Reseteamos la opacidad a 0
    setCurrentSrc(iframeSrc); // Forzamos el cambio de src
  }, [iframeSrc]);

  const handleClick = () => toggleFullScreen();

  const handleRefresh = () => {
    const newSrc = `${iframeSrc}${iframeSrc.includes('?') ? '&' : '?'}refresh=${Date.now()}`;
    setIframeLoaded(false);
    setCurrentSrc(newSrc);
  };

  return (
    <Page className={className}>
      <motion.div
        initial="normal"
        variants={pageVariants}
        animate={fullScreen ? "fullScreen" : "normal"}
        className="flex w-full h-full transform-gpu"
      >
        <motion.div
          initial="normal"
          variants={iframeContainerVariants}
          className="w-full bg-[#e2e2e2] rounded-[1rem] transform-gpu
          relative p-5"
        >
        <div className="absolute top-5 left-5 right-5 bottom-5 bg-navy"></div>
          <motion.iframe
            src={currentSrc}
            title=""
            className="w-full h-full border-none transform-gpu overflow-y-auto"
            onLoad={() => setIframeLoaded(true)}
            key={currentSrc}
            initial={{ opacity: 0 }}
            animate={{ opacity: iframeLoaded ? 1 : 0 }}
            transition={iframeLoaded ? { duration: 0.5, ease: "easeInOut" } : { duration: 0 }}
          ></motion.iframe>
        </motion.div>
        <AnimatePresence initial={false}>
          {!fullScreen && (
            <>
            <MotionExpandButton
              initial={expandButtonAnimation.initial}
              animate={expandButtonAnimation.animate}
              exit={expandButtonAnimation.exit}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              onClick={handleClick}
              className={expandButtonClassName}
            />

            <RefreshExpandButton
              className="absolute top-[17.5rem] right-[9.2rem] w-[6.875rem] h-[6.875rem] focus:outline-none"
              initial={expandButtonAnimation.initial}
              animate={expandButtonAnimation.animate}
              exit={expandButtonAnimation.exit}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              onClick={handleRefresh}
            />
            </>
          )}
        </AnimatePresence>
      </motion.div>
      {children}
    </Page>
  );
}
